import type { Task, TaskCreate } from '@/shared/types'
import { API_URL, createHeaders } from './base'

export async function getTasks(): Promise<Task[]> {
  const response = await fetch(`${API_URL}/tasks`, {
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to fetch tasks')
  return response.json()
}

export async function getTask(id: number): Promise<Task> {
  const response = await fetch(`${API_URL}/tasks/${id}`, {
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to fetch task')
  return response.json()
}

export async function getTodayTasks(): Promise<Task[]> {
  const response = await fetch(`${API_URL}/tasks/today`, {
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to fetch today tasks')
  return response.json()
}

export async function createTask(task: TaskCreate): Promise<Task> {
  const response = await fetch(`${API_URL}/tasks`, {
    method: 'POST',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(task),
  })
  if (!response.ok) throw new Error('Failed to create task')
  return response.json()
}

export async function updateTask(id: number, updates: Partial<TaskCreate>): Promise<Task> {
  const response = await fetch(`${API_URL}/tasks/${id}`, {
    method: 'PUT',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(updates),
  })
  if (!response.ok) throw new Error('Failed to update task')
  return response.json()
}

export async function deleteTask(id: number): Promise<void> {
  const response = await fetch(`${API_URL}/tasks/${id}`, {
    method: 'DELETE',
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to delete task')
}
